import React from 'react';
import Footer from '../components/Footer';

export default function TermeniConditii() {
  return (
    <div className="page-with-footer">
      <div className="page-body">
        <div className="legal-page">
          <div className="legal-box">
            <h1>📄 Termeni și condiții</h1>
            <div className="legal-updated">Ultima actualizare: 2026 — Monitorizare Flotă, o marcă a SoftConsult</div>

            <p>
              Prezentul document reglementează utilizarea aplicației „Monitorizare Flotă"
              (denumită în continuare „Aplicația"), furnizată de SoftConsult. Prin trimiterea unei
              cereri de înregistrare a unei firme noi sau prin utilizarea Aplicației, confirmați că
              ați citit, înțeles și acceptat acești termeni și condiții, precum și{' '}
              <a href="/confidentialitate" target="_blank" rel="noopener noreferrer">
                Politica de confidențialitate
              </a>.
            </p>

            <h2>1. Descrierea serviciului</h2>
            <p>
              Aplicația oferă firmei client instrumente pentru gestiunea parcului auto: evidența
              autovehiculelor, cheltuielilor, alimentărilor de carburant, pieselor, reviziilor
              tehnice și generarea de rapoarte și alerte de expirare a documentelor.
            </p>

            <h2>2. Licența gratuită și limitele acesteia</h2>
            <div className="legal-highlight">
              ⚠️ Aplicația este pusă la dispoziție <b>gratuit</b>, în limita unui singur utilizator
              și a unui singur autovehicul per firmă înregistrată. Pentru un număr mai mare de
              utilizatori sau autovehicule este necesară o înțelegere separată cu SoftConsult
              privind un plan extins de utilizare.
            </div>

            <h2>3. Obligațiile utilizatorului</h2>
            <ul>
              <li>Să furnizeze date reale, complete și actualizate la înregistrarea firmei și a contului;</li>
              <li>Să păstreze confidențiale datele de autentificare (utilizator și parolă) și să nu le comunice terților;</li>
              <li>Să utilizeze Aplicația exclusiv în scopuri licite, legate de gestiunea propriului parc auto;</li>
              <li>Să își asume corectitudinea informațiilor introduse (cheltuieli, date tehnice ale vehiculelor, documente etc.), Aplicația fiind un instrument de evidență, nu de verificare a acestor date.</li>
            </ul>

            <h2>4. Disponibilitatea serviciului</h2>
            <p>
              SoftConsult depune eforturi rezonabile pentru menținerea Aplicației disponibile și
              funcționale, însă nu garantează o disponibilitate neîntreruptă de 100%. Aplicația
              poate fi indisponibilă temporar pentru mentenanță, actualizări sau din motive
              tehnice independente de voința noastră.
            </p>

            <h2>5. Backup, securitate și limitarea răspunderii</h2>
            <p>
              Pentru protejarea datelor introduse în Aplicație, se realizează o copie de siguranță
              (backup) zilnică a bazei de date.
            </p>
            <div className="legal-highlight">
              ⚠️ Backup-ul zilnic reprezintă o măsură tehnică de precauție, nu o garanție a
              recuperării integrale a datelor în orice situație. <b>SoftConsult nu își asumă
              răspunderea pentru pierderea, coruperea, indisponibilitatea temporară sau divulgarea
              datelor ca urmare a atacurilor cibernetice, tentativelor de acces neautorizat,
              breșelor de securitate provocate de terți sau altor evenimente independente de
              controlul rezonabil al operatorului.</b> Întreaga răspundere pentru eventualele
              consecințe ale unor astfel de evenimente — inclusiv, dar fără a se limita la, pierderi
              financiare, întreruperea activității sau imposibilitatea utilizării datelor — cade
              exclusiv în sarcina utilizatorului/firmei client. Recomandăm utilizatorilor să își
              păstreze, acolo unde este posibil, propriile copii ale documentelor esențiale
              introduse în Aplicație.
            </div>

            <h2>6. Limitarea generală a răspunderii</h2>
            <p>
              În limita maximă permisă de lege, SoftConsult nu răspunde pentru daune indirecte,
              incidentale sau de consecință rezultate din utilizarea sau imposibilitatea utilizării
              Aplicației. Aplicația este furnizată „ca atare" (as-is), fără garanții exprese sau
              implicite privind lipsa erorilor sau adecvarea pentru un scop anume.
            </p>

            <h2>7. Proprietate intelectuală</h2>
            <p>
              Aplicația, codul sursă, denumirea, elementele grafice și marca „Monitorizare Flotă"
              aparțin SoftConsult. Utilizatorului i se acordă un drept limitat, neexclusiv și
              netransferabil de utilizare a Aplicației, exclusiv în scopurile descrise mai sus.
            </p>

            <h2>8. Suspendarea sau încetarea contului</h2>
            <p>
              SoftConsult își rezervă dreptul de a suspenda sau închide un cont în cazul
              utilizării abuzive, frauduloase sau contrare acestor termeni, precum și la solicitarea
              expresă a utilizatorului/firmei client.
            </p>

            <h2>9. Modificarea termenilor</h2>
            <p>
              Acești termeni pot fi actualizați periodic. Continuarea utilizării Aplicației după
              publicarea modificărilor reprezintă acceptarea noii versiuni.
            </p>

            <h2>10. Legea aplicabilă</h2>
            <p>
              Prezentul document este guvernat de legislația română. Orice litigiu se va soluționa
              pe cale amiabilă, iar în lipsa unei soluții amiabile, de instanțele competente.
            </p>

            <h2>11. Contact</h2>
            <p>
              Pentru întrebări legate de acești termeni, ne puteți contacta prin intermediul{' '}
              <a href="https://www.softconsult.ro" target="_blank" rel="noopener noreferrer">
                softconsult.ro
              </a>.
            </p>

            <a className="legal-back" href="/login">← Înapoi la pagina de conectare</a>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
